import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '@core/layout/footer/footer.component';
import { NavigationComponent } from '@core/layout/navigation/navigation.component';

@Component({
    selector: 'pn-page',
    standalone: true,
    imports: [NavigationComponent, RouterModule, FooterComponent],
    template: `
        <pn-navigation />
        <div class="pt-[94px] mb:pt-[64px]">
            <router-outlet />
        </div>
        <pn-footer />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent {}
